"use client";

import TiltedCard from "@/components/TiltedCard";
import type { Product } from "@/config/products";
import { productCategories, gameTags } from "@/config/products";

/** Plan key for products with pricePlans (e.g. day, week, month, lifetime). */
export type PlanKey = string;

function getStartingPrice(product: Product): number {
  if (product.pricePlans) {
    const validPrices = Object.values(product.pricePlans).filter(
      (p) => typeof p === "number" && p > 0,
    );
    return validPrices.length > 0 ? Math.min(...validPrices) : product.price;
  }
  return product.price;
}

interface ProductCardProps {
  product: Product;
}

export function ProductCard({ product }: ProductCardProps) {
  const categoryLabel = productCategories[product.category] || product.category;
  const gameLabel = gameTags[product.gameTag] || product.gameTag;
  const tags = [categoryLabel, gameLabel].filter(Boolean);

  const startingPrice = getStartingPrice(product);

  return (
    <TiltedCard
      imageSrc={product.mediaUrl}
      altText={product.name}
      title={product.name}
      category={categoryLabel}
      gameTag={gameLabel}
      tags={tags}
      mediaType={product.mediaType}
      pricePlans={product.pricePlans as Record<string, number> | undefined}
      imageWidth="100%"
      rotateAmplitude={2.5}
      scaleOnHover={1.02}
      showMobileWarning={false}
      showTooltip={false}
      showFavorite
      startingPrice={startingPrice}
      href={`/product/${product.id}`}
    />
  );
}


